export default __webpack_public_path__ + "assets/models/2166f52bece02b7a57472a5685cedc3e.glb";